/**
 * Kochava API wrapper.
 *
 * I'm leaving this in js because the code snippets don't play well with
 * type script and I don't want to mess with them.
 *
 */

const KOCHAVA_APP_ID_WEB_DEV = 'kostyleseat-q98q1';
const KOCHAVA_APP_ID_WEB_PROD = 'kostyleseat-web-prod-5q0ay793u';
const KOCHAVA_APP_ID_ANDROID = 'kostyleseat-android-7t408i17g';
const KOCHAVA_APP_ID_IOS = 'kostyleseat-ios-hcse';

/**
 * Configure App Tracking Transparency support in Kochova
 * https://support.kochava.com/sdk-integration/ios-sdk-integration/ios-using-the-sdk/
*/

/** Enable ATT support */
const KOCHAVA_IOS_ATT_PROMPT_ENABLED = true;

/** Tell Kochova to wait this many seconds for the user to respond to the prompt */
const KOCHAVA_IOS_ATT_PROMPT_DELAY = 180;

/** Whether Kochova should auto-request tracking permission. This is false because we
   * want to customize when to trigger the prompt via cordova-plugin-idfa.
   */
const KOCHAVA_IOS_ATT_PROMPT_AUTO_REQUEST = false;

const init = (APP, production) => {
  if (APP && 'KochavaTracker' in window) {
    // Use phonegap sdk
    // https://support.kochava.com/sdk-integration/sdk-kochavatracker-phonegapcordova-plugin/
    const config = {
      [window.KochavaTracker.PARAM_IOS_APP_GUID_STRING_KEY]: KOCHAVA_APP_ID_IOS,
      [window.KochavaTracker.PARAM_ANDROID_APP_GUID_STRING_KEY]: KOCHAVA_APP_ID_ANDROID,
      [window.KochavaTracker.PARAM_APP_TRACKING_TRANSPARENCY_ENABLED_BOOL_KEY]:
        KOCHAVA_IOS_ATT_PROMPT_ENABLED,
      [window.KochavaTracker.PARAM_APP_TRACKING_TRANSPARENCY_WAIT_TIME_DOUBLE_KEY]:
        KOCHAVA_IOS_ATT_PROMPT_DELAY,
      [window.KochavaTracker.PARAM_APP_TRACKING_TRANSPARENCY_AUTO_REQUEST_BOOL_KEY]:
        KOCHAVA_IOS_ATT_PROMPT_AUTO_REQUEST,
    };

    window.KochavaTracker.configure(config);
  } else {
    // Initialize web sdk
    // https://support.kochava.com/sdk-integration/web-sdk-integration/
    // IMPORTANT: This snippet code was modified to declare `const stub`,
    // on a separate line, otherwise the snippet Kochava provides causes
    // an error at runtime.
    const appId = production ? KOCHAVA_APP_ID_WEB_PROD : KOCHAVA_APP_ID_WEB_DEV;
    const version = 'v2.2';
    const autopage = false;
    const cache = true;
    const verbose = !production;
    const cookies = false;
    const identityLink = null;
    const disableAutoInstall = false;
    /* eslint-disable */
    !(function (e, t, o, a, n, c, s, i) {
      const r = window.kochava = window.kochava || [];
      if (r.loaded) window.console && console.error && console.error('Kochava snippet already included');
      else {
        r.loaded = !0, r.methods = ['page', 'identify', 'activity', 'conversion', 'init', 'submitCookieId', 'getCookieId', 'getMAID', 'getKochavaId'];
        const stub = function (e) {
          return function () {
            const t = Array.prototype.slice.call(arguments);
            return t.unshift(e), typeof r.push === 'function' && r.push(t), r;
          };
        };
        for (let d = 0; d < r.methods.length; d++) {
          const u = r.methods[d];
          r[u] = stub(u);
        }
        r.init((new Date()).getTime(), e, n, c, s, i),
        (function () {
          const e = document.createElement('script');
          e.type = 'text/javascript', e.async = !0, e.src = `${document.location.protocol === 'https:' ? 'https://' : 'http://'}assets.kochava.com/kochava.js/${t}/kochava.min.js`, a || (e.src = `${e.src}?c=${Math.random()}`);
          const o = document.getElementsByTagName('script')[0];
          o.parentNode.insertBefore(e, o);
        }()), o && e != null && e != '' && r.page();
      }
    }(appId, version, autopage, cache, verbose, cookies, identityLink, disableAutoInstall));
    /* eslint-enable */
  }
};

/**
 * Send an event to Kochava.
 *
 * @param {string} event - event name to track
 * @param {Object} props - properties to send
 */
const trackEvent = (isApp, event, props = {}) => {
  if (isApp && 'KochavaTracker' in window) {
    // app
    window.KochavaTracker.sendEventMapObject(event, props);
  } else if ('kochava' in window) {
    // web
    window.kochava.activity(event, props);
  }
};

/**
 * Available API methods.
 */
const api = {
  init,
  trackEvent,
};

export default api;
